export default __webpack_public_path__ + "static/cvc-d96c272bf59c67192473fd1fda5ae88b.mp4";